module.exports = __webpack_public_path__ + "static/media/alumio-symbol.79114255.svg";